module.exports = __webpack_public_path__ + "img/Logo_new_year.svg";